import api from '../api';

/**
 * Fetches a statement report for a given store within a specified date range.
 *
 * @param {string} store_code - The code of the store.
 * @param {Date} start_date - The start date in RFC3339 format.
 * @param {Date} end_date - The end date in RFC3339 format.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const getOrderSummaryStatement = async (store_code, start_date, end_date) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/statistic/getOrderSummaryStatement`;

  try {

    const response = await api.post(endpoint, {
      store_code,
      start_date,
      end_date,
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching statement:', error);
    throw error;
  }
}

export default getOrderSummaryStatement;
